<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editData" ref="editDataRef" label-width="180px">
        <el-form-item label="材料编号" class="addAdminForm">
          <el-input v-model="editData.Bomsn" placeholder="请输入材料编号"></el-input>
        </el-form-item>
        <el-form-item label="材料名称" class="addAdminForm">
          <el-input v-model="editData.Name" placeholder="请输入品名"></el-input>
        </el-form-item>
        <el-form-item label="规格型号" class="addAdminForm">
          <el-input v-model="editData.Specifications" placeholder="请输入规格型号"></el-input>
        </el-form-item>
        <el-form-item label="数量" class="addAdminForm">
          <el-input v-model="editData.Num" placeholder="请输入预算单价"></el-input>
        </el-form-item>
        <el-form-item label="单价（未税）" class="addAdminForm" v-if="SubRule_MadeManagement_AmountProjectbom">
          <el-input v-model="editData.Price" placeholder="请输入单价（未税）"></el-input>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickback">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editData: {},
      parentlist: [],
      SubRule_MadeManagement_AmountProjectbom: false
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata, parentlist, SubRuleMadeManagementAmountProjectbom) {
      this.editData = parentdata
      this.parentlist = parentlist
      this.SubRule_MadeManagement_AmountProjectbom = SubRuleMadeManagementAmountProjectbom
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditProjectbom()
    },
    apiEditProjectbom: function () {
      var that = this
      var amount = parseFloat(that.editData.Num) * parseFloat(that.editData.Price)
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomid: that.editData.Id,
        bomsn: that.editData.Bomsn,
        name: that.editData.Name,
        specifications: that.editData.Specifications,
        num: that.editData.Num,
        price: that.editData.Price,
        amount: amount
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditProjectbom, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
